/*
  CRO 2026-09-26: celebrate an offer the moment a cart change unlocks it, and say what the next one is.
    "🎉 Free delivery unlocked!"  ·  "Add ₹1,100 more for a FREE varnish (worth ₹79)"
  Thresholds and wording mirror the offers bar in snippets/cro-cart-reassurance.liquid:
    free delivery ₹999+ and free varnish ₹2,599+ count the whole order (minus the free varnish line);
    extra 5% = 2+ kits, 10% = ₹4,999+ in kits (only the better of the two applies at checkout).
  Fires on Dawn's cartUpdate (add to cart, quantity change). Remembers what was already unlocked in
  sessionStorage, so it celebrates each offer once and not on every page. Stays quiet while the
  Buy-it-now flow (cro-buynow-gift.js) is heading to checkout, which has its own celebration.
  Config: window.CRO_OFFERS.
*/
(() => {
  if (window.__croCelebrate) return;
  window.__croCelebrate = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const KEY = 'cro_unlocked_v1';
  const rupees = (paise) => '₹' + Math.ceil(paise / 100).toLocaleString('en-IN');
  const isGift = (i) => i.properties && i.properties._free_gift;

  const load = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } };
  const save = (v) => { try { sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode */ } };

  function read(cart) {
    const cfg = window.CRO_OFFERS || {};
    const shipMin = cfg.shipMin || 99900, giftMin = cfg.giftMin || 259900, bulkMin = cfg.bulkMin || 499900;
    let base = 0, kitBase = 0, kits = 0;
    cart.items.forEach((i) => {
      if (!isGift(i)) base += i.original_line_price;
      if (/kit/i.test(i.product_type || '')) { kits += i.quantity; kitBase += i.original_line_price; }
    });
    const on = { ship: base >= shipMin, gift: base >= giftMin, five: kits >= 2, ten: kitBase >= bulkMin };
    let next;
    if (!on.ship) next = `Add <b>${rupees(shipMin - base)}</b> more for <b>free delivery</b>`;
    else if (!on.gift) next = `Add <b>${rupees(giftMin - base)}</b> more for a <b>FREE varnish</b> (worth ₹79)`;
    else if (!on.ten && kits === 1) next = `Add <b>1 more kit</b> for an extra <b>5% off</b>`;
    else if (!on.ten) next = `Add <b>${rupees(bulkMin - kitBase)}</b> more in kits for <b>10% off</b> all kits`;
    else next = `You've unlocked every offer. Enjoy! 🎨`;
    return { on, next };
  }

  const HEADLINES = {
    ten: ['10% off all kits unlocked!', 'Applied automatically at checkout.'],
    five: ['Extra 5% off unlocked!', 'For picking 2 kits. Applied at checkout.'],
    gift: ['Free varnish added!', '15 ml high-gloss varnish, on us.'],
    ship: ['Free delivery unlocked!', 'Shipping across India is on us.'],
  };
  const SHORT = { ten: '10% off all kits', five: 'extra 5% off', gift: 'a free varnish', ship: 'free delivery' };

  function confetti(fromX, fromY) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const c = document.createElement('canvas');
    c.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483001';
    document.body.appendChild(c);
    const dpr = window.devicePixelRatio || 1;
    c.width = innerWidth * dpr; c.height = innerHeight * dpr;
    const ctx = c.getContext('2d'); ctx.scale(dpr, dpr);
    const colors = ['#FF6B6B', '#FFD93D', '#6BCB77', '#4D96FF', '#C77DFF', '#FF9F45'];
    const bits = Array.from({ length: 110 }, () => ({
      x: fromX, y: fromY, vx: (Math.random() - 0.5) * 13, vy: Math.random() * -12 - 3,
      w: 5 + Math.random() * 6, h: 7 + Math.random() * 7, r: Math.random() * 3, vr: (Math.random() - 0.5) * 0.3,
      color: colors[(Math.random() * colors.length) | 0],
    }));
    const start = performance.now();
    (function frame(t) {
      ctx.clearRect(0, 0, innerWidth, innerHeight);
      bits.forEach((b) => {
        b.vy += 0.4; b.vx *= 0.99; b.x += b.vx; b.y += b.vy; b.r += b.vr;
        ctx.save(); ctx.translate(b.x, b.y); ctx.rotate(b.r); ctx.fillStyle = b.color;
        ctx.fillRect(-b.w / 2, -b.h / 2, b.w, b.h); ctx.restore();
      });
      if (t - start < 2000) requestAnimationFrame(frame); else c.remove();
    })(start);
  }

  function toast(keys, next) {
    document.querySelectorAll('.cro-cel').forEach((e) => e.remove());
    if (!document.getElementById('cro-cel-style')) {
      const s = document.createElement('style');
      s.id = 'cro-cel-style';
      s.textContent = `
        .cro-cel{position:fixed;z-index:2147483002;top:8.6rem;right:1.2rem;width:min(36rem,calc(100vw - 2.4rem));
          background:#fff;color:#1a1a1a;border-radius:14px;padding:1.4rem 1.6rem 1.4rem 1.4rem;display:flex;gap:1.2rem;
          box-shadow:0 10px 32px rgba(0,0,0,.22);border:2px solid #FFD93D;animation:cro-cel-in .45s cubic-bezier(.2,1.4,.4,1)}
        .cro-cel__icon{font-size:3rem;line-height:1}
        .cro-cel__title{margin:0;font-size:1.7rem;font-weight:700;line-height:1.3}
        .cro-cel__sub{margin:.2rem 0 0;font-size:1.3rem;opacity:.7}
        .cro-cel__next{margin:.8rem 0 0;font-size:1.35rem;padding:.6rem .8rem;border-radius:8px;background:#F4F1FF}
        .cro-cel__x{position:absolute;top:.4rem;right:.6rem;background:none;border:0;font-size:1.8rem;cursor:pointer;opacity:.5;padding:.4rem}
        .cro-cel.is-out{transition:opacity .3s,transform .3s;opacity:0;transform:translateY(-8px)}
        @keyframes cro-cel-in{from{opacity:0;transform:translateY(-10px) scale(.92)}to{opacity:1;transform:none}}
        @media (min-width:750px){cart-drawer.active ~ .cro-cel,.cro-cel.beside-drawer{right:calc(min(40rem,100vw) + 1.6rem)}}
        @media (max-width:749px){.cro-cel{top:7.2rem;left:1.2rem;right:1.2rem;width:auto}}`;
      document.head.appendChild(s);
    }
    const [title, one] = HEADLINES[keys[0]];
    const sub = keys.length > 1 ? `Plus ${keys.slice(1).map((k) => SHORT[k]).join(' and ')}!` : one;
    const el = document.createElement('div');
    el.className = 'cro-cel';
    el.setAttribute('role', 'status');
    el.innerHTML = `<div class="cro-cel__icon" aria-hidden="true">🎉</div><div>
      <p class="cro-cel__title">${title}</p><p class="cro-cel__sub">${sub}</p>
      <p class="cro-cel__next">${next}</p></div>
      <button type="button" class="cro-cel__x" aria-label="Close">×</button>`;
    // laptop/desktop: sit to the left of the open cart drawer so the items stay visible
    if (document.querySelector('cart-drawer.active')) el.classList.add('beside-drawer');
    document.body.appendChild(el);
    const close = () => { el.classList.add('is-out'); setTimeout(() => el.remove(), 320); };
    el.querySelector('.cro-cel__x').addEventListener('click', close);
    setTimeout(close, 5500);
    const r = el.getBoundingClientRect();
    confetti(r.left + 40, r.top + 30);
  }

  async function check(celebrate) {
    try {
      const cart = await (await fetch(`${root}cart.js`)).json();
      const now = read(cart);
      const before = load();
      save(now.on);
      if (!celebrate || !before) return;
      // 5% and 10% don't stack: once 10% is on, 5% isn't news
      const fresh = ['ten', 'five', 'gift', 'ship'].filter((k) => now.on[k] && !before[k] && !(k === 'five' && now.on.ten));
      if (!fresh.length) return;
      setTimeout(() => { if (!window.__croCheckingOut) toast(fresh, now.next); }, 450);
    } catch (e) {
      console.warn('[cro-cart-celebrate]', e);
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(() => check(true), 60));
  }
  // first page of the visit: remember what the cart already had, without celebrating it
  if (!load()) check(false);
})();
